import { render, staticRenderFns } from "./AdminSuppliersPage.vue?vue&type=template&id=7a2a9af7&scoped=true&lang=pug&"
import script from "./AdminSuppliersPage.vue?vue&type=script&lang=js&"
export * from "./AdminSuppliersPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuppliersPage.vue?vue&type=style&index=0&id=7a2a9af7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a9af7",
  null
  
)

export default component.exports